import { QuotesFormComponent } from './quotes-form/quotes-form.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuotesComponent } from './quotes.component';
import { RoleGuard } from 'src/app/shared/guards/role.guard';

const routes:Routes=[
  {path:'',redirectTo:'list',pathMatch:'full'},
  {path:'list',component:QuotesComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}},
  {path:'new',component:QuotesFormComponent,canActivate:[RoleGuard],data:{roles: ["admin","user"]}},
  {path:'edit',component:QuotesFormComponent,canActivate:[RoleGuard],data:{roles: ["admin","user"]}},
]

// o Administrador Khuzela faz CRUD
// o Utilizador Khuzela  só Lê
// o Manager do Clube só Lê
// o Utilizador do Clube só Lê


@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[
    RouterModule
  ]
})
export class QuotesRoutingModule { }
